<template>
  <component :is="tag" class="publish-title" :class="`publish-title--${level}`">
    <slot>{{ text }}</slot>
    <!-- （多选） -->
    <span v-if="multiple" class="publish-title__meta">{{
      $t("adminFlows.multipleSelection")
    }}</span>
  </component>
</template>

<script>
export default {
  name: "PublishTitle",
  props: {
    text: {
      type: String,
      default: "",
    },
    level: {
      type: String,
      default: "field",
      validator: (value) =>
        [
          "page",
          "module",
          "dialog",
          "section",
          "group",
          "field",
          "assist",
        ].includes(value),
    },
    tag: {
      type: String,
      default: "div",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./tokens.less";

.publish-title {
  margin: 0;
  color: @publish-text-primary;
}

.publish-title--page {
  font-size: 17px;
  font-weight: 700;
  line-height: 24px;
}

.publish-title--module {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.publish-title--dialog {
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
}

.publish-title--section {
  position: relative;
  padding-left: 10px;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;

  &::before {
    position: absolute;
    top: 3px;
    left: 0;
    width: 3px;
    height: 14px;
    background: #4f8cf7;
    border-radius: 999px;
    content: "";
  }
}

.publish-title--group {
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
}

.publish-title--field {
  color: @publish-text-regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.publish-title--assist {
  color: @publish-text-secondary;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}

.publish-title__meta {
  font: inherit;
  color: inherit;
}

.publish-title.section-title {
  padding: 0 4px 8px;
}

.publish-title.section-title--inside {
  padding: 12px 14px 6px;
}

.publish-title.section-title--toggle {
  padding: 0;
}

.publish-title.field-block__title {
  margin-bottom: 9px;
  color: @publish-text-regular;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
</style>
